export default class RelatedList {
    
    constructor(type = '') {
        let hash  = window?.location?.hash??'';
        if(!type && hash){
            try{
                this.type = atob(hash.replace('#', ''));
            }catch(e){}
            if(this.type){
                this.load();
            }
        }else{
            this.type     = type;
            this.groupId  = null;
            this.data     = null;
        }
    }

    getGroupId(){
        return this.groupId;
    }

    getData(){
        return this.data;
    }


    getType(){
        return this.type;
    }


    save(data, groupId) {
        this.data     = data;
        this.groupId  = groupId;
        let state     = {data,groupId,type:this.type};
        this.setUrlWithKey(state);
    }

    setUrlWithKey(state){
        let loc = window.location;
        let url = loc.protocol+'//'+ loc.host + loc.pathname + (loc.search?loc.search:"") + '#' + btoa(this.type);
        history.pushState(state, "", url);
    }

    remove(){
        history.replaceState(null, null, ' ');
    }

    load(){
        let state     = history?.state??{};
        this.data     = state.data??null;
        this.groupId  = state.groupId??null;
    }
}